import { initAdv, injectAdv } from '@sky-uk/sky-adv';

export const init = ($advSkinDataNode) => {
  injectAdv($advSkinDataNode);
  initAdv($advSkinDataNode);
};
